import type {
  BaseFilterProps,
  RateFiltersSchema,
} from "~/types/schemas/Product/Organism/filters";

export const specialTagsFilter: BaseFilterProps[] = [
  {
    q_key: "special_tags",
    value: "trendy",
    label: "product.filters.labels.trending",
  },
  {
    q_key: "special_tags",
    value: "best_seller",
    label: "product.filters.labels.best_seller",
  },
  {
    q_key: "special_tags",
    value: "recommended",
    label: "product.filters.labels.recommended",
  },
  {
    q_key: "special_tags",
    value: "featured",
    label: "product.filters.labels.featured",
  },
  {
    q_key: "special_tags",
    value: "clearance",
    label: "product.filters.labels.clearance",
  },
];

export const rateFilter: RateFiltersSchema[] = Array.from(
  { length: 5 },
  (_, index) => ({
    q_key: "rate",
    type: "RATE",
    value: (index + 1).toString(),
  }),
);
